import React, { lazy, Suspense } from 'react';

const InsertDecorationModal = lazy(() =>
  import('./insert-decoration-modal/insert-decoration-modal').then(({ InsertDecorationModal }) => ({
    default: InsertDecorationModal,
  }))
);

const LineSpacingPanelComponent = (props: $TSFixMe) => (
  <Suspense fallback={<div style={{ width: 143 }} />}>
    <InsertDecorationModal {...props} />
  </Suspense>
);

export default LineSpacingPanelComponent;
